/*
 * BB-CUSTOM: Native product tabs (replaces Smart Tabs by Kava).
 * Progressive enhancement: without JS all panels are visible (stacked).
 * With JS it behaves as an accessible tab interface (WAI-ARIA).
 */
(function () {
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    root.classList.add('is-enhanced');

    function activate(i, focusTab) {
      tabs.forEach(function (tab, idx) {
        var selected = idx === i;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('is-active', selected);
      });
      panels.forEach(function (panel, idx) {
        panel.classList.toggle('is-active', idx === i);
      });
      if (focusTab && tabs[i]) tabs[i].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = (i + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = (i - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = tabs.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        activate(next, true);
      });
    });

    activate(0);
  }

  function init() {
    document.querySelectorAll('[data-bb-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
